export const FILLED = "filled";
export const EMPTY = "empty";
export const HALF_FILLED = "half-filled";

const StarType = { FILLED, EMPTY, HALF_FILLED };
export default StarType;
